import * as React from 'react'
import AsyncSelect from 'react-select/lib/Async'

import UsersQuery from './queries/UsersLeanQuery'

export interface SelectOption {
  value: string
  label: string
}

export interface UserSelectProps {
  autoFocus?: boolean
  multi?: boolean
  name?: string
  onFocus?: any
  onBlur?: any
  onChange: (ids: SelectOption[]) => void
  value: SelectOption[]
  styles?: any
}

export class UserSelect extends React.Component<UserSelectProps> {
  render() {
    return (
      <UsersQuery>
        {({ refetch, data }) => {
          return (
            <AsyncSelect
              cacheOptions={true}
              defaultOptions={true}
              loadOptions={async input => {
                const result = await refetch({ name: input })

                if (result.errors || result.data == null) {
                  console.error('Error during fetching users', result.errors)

                  return []
                }

                const infos: SelectOption[] = result.data.users.map(user => ({
                  value: user.id,
                  label: user.name || ''
                }))

                return infos
              }}
              isMulti={this.props.multi === true}
              autoFocus={this.props.autoFocus}
              onChange={this.props.onChange}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              name={this.props.name}
              styles={this.props.styles}
            />
          )
        }}
      </UsersQuery>
    )
  }
}

export default UserSelect



// WEBPACK FOOTER //
// ./src/components/UserSelect.tsx